import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import layoutContent from './content/content.vue'
import { useRouter } from 'vue-router'
import { useStore } from "@/store/index";
import layoutHeader from './header/header.vue'
import layoutMenu from './menu/menu.vue'
import store from "@/store/index";

interface childMenu {
  id: number,
  name: string,
  path: string
}

interface menu {
  id: number,
  title: string,
  list: childMenu[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const value = ref(0)

const ustore = useStore();

const menuList: menu[][] = [
  [
    {
      id: 1,
      title: '地产项目',
      list: [
        {
          id: 13,
          name: '全部地产项目',
          path: '/middleGround/project/ProjectList'
        },
      ]
    },
    {
      id: 2,
      title: '楼盘招商活动',
      list: [
        {
          id: 24,
          name: '全部招商活动',
          path: '/middleGround/invest/InvestList'
        },
        {
          id: 17,
          name: '待审核的报名',
          path: '/middleGround/invest/InvestWillAuditApplyList'
        },
        {
          id: 15,
          name: '已审核的报名',
          path: '/middleGround/invest/InvestApplyList'
        },
        /*{
          id: 18,
          name: '统计表',
          path: '/middleGround/invest/investStat'
        }*/
      ]
    },
    {
      id: 2,
      title: '招募策划公司活动',
      list: [
        {
          id: 24,
          name: '全部招募活动',
          path: '/middleGround/recruit/RecruitList'
        },
        {
          id: 17,
          name: '待审核的报名',
          path: '/middleGround/recruit/RecruitWillAuditApplyList'
        },
        {
          id: 15,
          name: '已审核的报名',
          path: '/middleGround/recruit/RecruitApplyList'
        },
      ]
    },
  ],
  [
    {
      id: 2,
      title: '社区营销活动',
      list: [
        {
          id: 25,
          name: '营销活动',
          path: '/middleGround/community/CommunityList'
        },
        // {
        //   id: 15,
        //   name: '报名列表',
        //   path: '/middleGround/community/communityApplyList'
        // },
        // {
        //   id: 17,
        //   name: '待审核报名',
        //   path: '/middleGround/community/CommunityWillAuditApplyList'
        // },
        /*{
          id: 18,
          name: '统计表',
          path: '/middleGround/community/CommunityStat'
        }*/
      ]
    },
  ],
  [
    {
      id: 1,
      title: '招募人才',
      list: [
        {
          id: 13,
          name: '全部招募需求',
          path: '/middleGround/#'
        },
        {
          id: 14,
          name: '待审核的简历',
          path: '/middleGround/#'
        },
        {
          id: 15,
          name: '已审核的简历',
          path: '/middleGround/#'
        },
      ]
    },
  ],
  [
    {
      id: 3,
      title: '会员账号管理',
      list: [
        {
          id: 5,
          name: '账号管理',
          path: '/middleGround/member/accountList'
        },
        {
          id: 6,
          name: '角色管理',
          path: '/middleGround/member/companyRole'
        },
        {
          id: 7,
          name: '下属企业',
          path: '/middleGround/member/subCompanyList'
        },
        {
          id: 8,
          name: '操作日志',
          path: '/middleGround/member/operateLog'
        },
      ]
    },
    {
      id: 3,
      title: '会员资料',
      list: [
        {
          id: 6,
          name: "基本资料管理",
          path: "/middleGround/member/index"
        },
        {
          id: 4,
          name: '公司图册',
          path: '/middleGround/member/photoAlbum'
        },
        {
          id: 7,
          name: '财务管理',
          path: '/middleGround/member/membershipFees'
        },
        {
          id: 8,
          name: '我的社区营销',
          path: '/middleGround/member/prototypeRoomList'
        },
        {
          id: 10,
          name: '我的商务合作',
          path: '/middleGround/member/businessList'
        },
      ]
    },
  ],
  [
    {
      id: 4,
      title: '个人事务',
      list: [
        {
          id: 1,
          name: '我的消息',
          path: '/middleGround/my/news'
        },
        {
          id: 2,
          name: '我报名的',
          path: '/middleGround/my/apply'
        },
        {
          id: 3,
          name: '我订阅的',
          path: '/middleGround/my/subscribe'
        },
      ],

    },
    {
      id: 4,
      title: '我的帐号',
      list: [{
        id: 1,
        name: '个人资料',
        path: '/middleGround/my/information'
      },
      {
        id: 2,
        name: '修改密码',
        path: '/middleGround/my/password'
      },
      ],

    }
  ]
];

const navList = ref(menuList);

const handleTabs = (e: number) => {
  value.value = e
  router.push(navList.value[e][0].list[0].path)
}

const currPath = router.currentRoute.value.path;
navList.value.map((header: any, index: number, array: any) => {
  header.map((items: any) => {
    items.list.map((item: any) => {
      const has = currPath.toLowerCase().startsWith(item.path.toLowerCase());
      if (has) {
        value.value = index;
      }
    })
  })

});


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "mg-wrap" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "mg-header" }, {
        default: _withCtx(() => [
          _createVNode(layoutHeader, { onOnTabs: handleTabs })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "mg-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, { class: "mg-aside" }, {
            default: _withCtx(() => [
              _createVNode(layoutMenu, {
                tab: navList.value[value.value]
              }, null, 8, ["tab"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, { class: "mg-main" }, {
            default: _withCtx(() => [
              _createVNode(layoutContent)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})